import { createContext, useContext, type ReactNode } from "react";

const BlockScrollContainerContext = createContext<HTMLElement | null | undefined>(undefined);

export interface BlockScrollContainerProviderProps {
  scrollElement: HTMLElement | null;
  children: ReactNode;
}

export const BlockScrollContainerProvider = ({ scrollElement, children }: BlockScrollContainerProviderProps) => (
  <BlockScrollContainerContext.Provider value={scrollElement}>{children}</BlockScrollContainerContext.Provider>
);

/**
 * The scrolling element of the enclosing {@link BlockContent}, for a virtualized list that must not
 * nest its own scroll container inside it.
 *
 * The element itself rather than a ref to it, so a consumer re-renders when it attaches or is swapped.
 * A ref would hand descendants a value whose mutations they cannot observe.
 *
 * `undefined` outside a `BlockContent` — a list rendered on its own keeps owning its scrolling — and
 * `null` inside one whose scroller has not attached yet.
 */
export const useBlockScrollContainer = (): HTMLElement | null | undefined => useContext(BlockScrollContainerContext);
